"use client";

import { useSession } from "next-auth/react";

interface SessionLoadingGateProps {
  children: React.ReactNode;
}

/**
 * Blocks rendering until NextAuth session is resolved (loading → authenticated/unauthenticated).
 * Prevents flash of wrong content; portal/onboarding routing is enforced by their layouts
 * via GET /api/user/onboarding-status + getPortalEntryUrl.
 */
export default function SessionLoadingGate({ children }: SessionLoadingGateProps) {
  const { status } = useSession();

  if (status === "loading") {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  return <>{children}</>;
}
